module.exports = __webpack_public_path__ + "img/tjzm.d08f10b0.png";